'use strict';

exports.__esModule = true;
exports.TextInputControl = exports.TextInputPlaceholder = exports.TextInputWrap = undefined;

var _templateObject = _taggedTemplateLiteralLoose(['\n  position: relative;\n  z-index: 2;\n'], ['\n  position: relative;\n  z-index: 2;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  line-height: 10px;\n  background-color: ', ';\n  top: -4px;\n  font-size: 12px;\n  padding: ', ';\n  z-index: 3;\n  color: ', ';\n'], ['\n  line-height: 10px;\n  background-color: ', ';\n  top: -4px;\n  font-size: 12px;\n  padding: ', ';\n  z-index: 3;\n  color: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  line-height: 55px;\n  margin-left: ', ';\n  position: absolute;\n  top: 0;\n  transition: all 200ms ease;\n  color: ', ';\n  z-index: -1;\n  &:focus {\n    ', ';\n  }\n  ', '\n'], ['\n  line-height: 55px;\n  margin-left: ', ';\n  position: absolute;\n  top: 0;\n  transition: all 200ms ease;\n  color: ', ';\n  z-index: -1;\n  &:focus {\n    ', ';\n  }\n  ', '\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  display: block;\n  width: 100%;\n  font-size: 16px;\n  font-weight: ', ';\n  background-color: transparent;\n  background-clip: padding-box;\n  color: ', ';\n\n  padding: ', ';\n  border: 1px solid ', ';\n  border-color: ', ';\n  border-radius: ', ';\n  height: 55px;\n  &:focus, &:-webkit-autofill {\n    ~ ', ' {\n      ', ';\n    }\n  }\n\n  &:disabled,\n  &[readonly] {\n    background-color: ', ';\n    opacity: 1;\n  }\n'], ['\n  display: block;\n  width: 100%;\n  font-size: 16px;\n  font-weight: ', ';\n  background-color: transparent;\n  background-clip: padding-box;\n  color: ', ';\n\n  padding: ', ';\n  border: 1px solid ', ';\n  border-color: ', ';\n  border-radius: ', ';\n  height: 55px;\n  &:focus, &:-webkit-autofill {\n    ~ ', ' {\n      ', ';\n    }\n  }\n\n  &:disabled,\n  &[readonly] {\n    background-color: ', ';\n    opacity: 1;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _spacing = require('../../../styles/spacing');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var TextInputWrap = exports.TextInputWrap = _styledComponents2.default.div(_templateObject);
var withValue = (0, _styledComponents.css)(_templateObject2, function (_ref) {
  var theme = _ref.theme;
  return theme.white;
}, (0, _spacing.space)(0, 5), function (_ref2) {
  var invalid = _ref2.invalid,
      theme = _ref2.theme;
  return invalid ? theme.errorColor : theme.textColor9D;
});
var TextInputPlaceholder = exports.TextInputPlaceholder = _styledComponents2.default.span(_templateObject3, (0, _spacing.space)(15), function (_ref3) {
  var invalid = _ref3.invalid,
      theme = _ref3.theme;
  return invalid ? theme.errorColor : theme.textColor9D;
}, withValue, function (_ref4) {
  var hasValue = _ref4.hasValue;
  return hasValue ? withValue : '';
});

var TextInputControl = exports.TextInputControl = _styledComponents2.default.input(_templateObject4, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeightMedium;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.textColor69;
}, (0, _spacing.space)(7, 12), function (_ref7) {
  var theme = _ref7.theme;
  return theme.textColorD8;
}, function (_ref8) {
  var invalid = _ref8.invalid,
      theme = _ref8.theme;
  return invalid ? theme.errorColor : theme.textColorD8;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.radiusSm || theme.borderRadiusDefault;
}, TextInputPlaceholder, withValue, function (_ref10) {
  var theme = _ref10.theme;
  return theme.grayE6;
});